import { Title, Text } from "ui/Typography"
import WarningOutlinedWithBg from "ui/WarningOutlinedWithBg"
import { Flex } from "antd"
import { Modal } from "ui/Modal"
import { spacings } from "themes/variables"
import PropTypes from "prop-types"
import ActionButtons from "../ActionButtons"

const AccountStatusPrompt = ({ visible, onCancel, onProceed, primaryLabel, title, text, primaryColor }) => {
  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      centered
      title={
        <Flex justify="center">
          <WarningOutlinedWithBg />
        </Flex>
      }
      width={450}
    >
      <Flex vertical gap={spacings.M}>
        <Title level={3}>{title}</Title>
        <Text>{text}</Text>
        <ActionButtons primaryColor={primaryColor} onSecondary={onCancel} onPrimary={onProceed} primaryLabel={primaryLabel} />
      </Flex>
    </Modal>
  )
}

AccountStatusPrompt.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onProceed: PropTypes.func,
  primaryLabel: PropTypes.node,
  title: PropTypes.node,
  text: PropTypes.node,
  primaryColor: PropTypes.string
}

export default AccountStatusPrompt
